// NPM Imports
import React, { Component } from "react";
import uuid from "react-native-uuid";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr, Input } from "@revvsales/components";

// Components Imports
import AddCustomDynamicField from "./AddCustomDynamicField";
import DynamicFieldFooter from "../DynamicFieldFooter/DynamicFieldFooter";

// Actions Imports
import { DocumentTemplateActions, EditorActions } from "../../../../actions";
import { updateDocumentClickedComponentID } from "../../../../actions/DocumentActions/index";

import { getDynamicFieldIDs } from "../../../../actions/DocumentTemplateActions/templateMethod";

// import utils
import { replaceTextAndApplyEntity } from "../../../../utils/draftUtils";
import {
  getUpdatedParentComponent,
  getComponentFromInfo,
} from "../../../../utils/documentUtils";
import { updateCellData } from "../../../RevvTable/utils";

// Internal Imports
import { COMMON } from "../../../../constants";

// Destructuring
const { DOCUMENT_LABELS } = COMMON;

// Destructuring
const {
  saveDynamicField,
  toggleDynamicFieldView,
  getCustomFieldType,
  addDynamicFieldinList,
  updateHoveredTemplateSectionId,
} = DocumentTemplateActions;
const { initEditorState } = EditorActions;

class DynamicFieldSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedId: "",
      filterBy: "",
    };
  }

  _onChange = (field, event) => {
    this.setState({
      [field]:
        event.target.value ||
        (event.target.attributes.value && event.target.attributes.value.value),
    });
  };

  _onChangeValue = (field, event) => {
    this.setState({
      [field]: event.target.value,
    });
  };

  _onNavigationBack = () => {
    const view = this.props.isDynamicFieldApplied ? "LIST" : "INFO";
    // const {
    //   section: { id },
    //   removeHighlightSelection,
    // } = this.props;
    // removeHighlightSelection(id);
    this.props.toggleDynamicFieldView(view);
  };

  _onNavigateToCustom = () => {
    this.props.getCustomFieldType();
  };

  _createDynamicField = () => {
    if (this.state.selectedId) {
      const {
        selectedText,
        section,
        editorState,
        components,
        activeComponentMeta,
      } = this.props;

      const oldFormFields = getDynamicFieldIDs(components);

      const selectedField = this.props.fields.find(
        field => field.id === this.state.selectedId,
      );
      const textToReplace = selectedField.label;
      const uniqueId = uuid.v4();
      const entityData = {
        id: uniqueId,
        dynamicFieldId: this.state.selectedId,
        selectedText,
        label: textToReplace,
        value: null,
      };

      const updatedEditorState = replaceTextAndApplyEntity(
        editorState,
        textToReplace,
        entityData,
        selectedText,
      );

      const { type } = section;
      if (type === "HTML") {
        const {
          undoStack = [],
          currentContent: currentSectionContent,
        } = section;
        if (currentSectionContent) {
          undoStack.push(currentSectionContent);
        }
        let updatedSection = {
          ...section,
          data: updatedEditorState.getCurrentContent(),
          undoStack,
        };
        this.props.addDynamicFieldinList(selectedField);
        updatedSection = getUpdatedParentComponent(
          components,
          activeComponentMeta,
          updatedSection,
        );
        updatedSection.oldFormFields = oldFormFields;
        this.props.saveDynamicField(updatedSection);
        this.props.updateDocumentClickedComponentID(
          section.id,
          true,
          section.type,
        );
        this.props.initEditorState(updatedEditorState, section);
        Toastr.showToastr({
          type: "success",
          message: `${
            DOCUMENT_LABELS["dynamic-label"]
          } Field successfully created`,
          timeout: 2000,
        });
      } else if (type === "Table") {
        const cellValue = {
          data: updatedEditorState.getCurrentContent(),
        };
        const tableData = getComponentFromInfo(
          components,
          section.componentMeta,
        );
        const rowID = section.rowID || section.componentMeta.tableRowId;
        const columnID = section.columnID || section.componentMeta.tableColId;
        const updatedTableData = updateCellData(
          tableData.data,
          rowID,
          columnID,
          cellValue,
        );
        delete section.tableData;
        delete section.columnID;
        delete section.rowID;
        section.data = updatedTableData;
        this.props.addDynamicFieldinList(selectedField);
        const updatedSection = getUpdatedParentComponent(
          components,
          section.componentMeta,
          cellValue,
        );
        updatedSection.oldFormFields = oldFormFields;
        this.props.saveDynamicField(updatedSection);
        this.props.updateDocumentClickedComponentID(
          activeComponentMeta.tableCellId,
          true,
          section.type,
        );
        this.props.initEditorState(updatedEditorState, section);

        Toastr.showToastr({
          type: "success",
          message: `${
            DOCUMENT_LABELS["dynamic-label"]
          } Field successfully created`,
          timeout: 2000,
        });
      }
      this.props.toggleDynamicFieldView("LIST");
    } else {
      Toastr.showToastr({
        type: "warning",
        message: `Kindly select a ${DOCUMENT_LABELS[
          "dynamic-label"
        ].toLowerCase()} field`,
        timeout: 2000,
      });
    }
  };

  render() {
    const filteredFieldList = this.props.fields.filter(
      field =>
        field.label.toLowerCase().indexOf(this.state.filterBy.toLowerCase()) !==
        -1,
    );
    return (
      <React.Fragment>
        <div
          className="document-dyn-field-pane"
          id="document-clause-options-pane-id">
          <div
            className="document-dynamic-options"
            data-test="dynamicfieldselect-document-dynamic-options-animated-slideinright">
            <div
              className="dynamicfieldselect-wrapper"
              data-test="dynamicfieldselect-wrapper">
              <div
                className="dynamicfieldselect-header"
                data-test="dynamicfieldselect-header">
                <div
                  className="dynamicfieldselect-back"
                  data-test="dynamicfieldselect-btn-icon-dynamicfieldselect-back-ico"
                  onClick={this._onNavigationBack}
                  onKeyPress={this._onNavigationBack}
                  role="button"
                  tabIndex="0">
                  <span className="btn-icon dynamicfieldselect-back-ico">
                    <FontAwesomeIcon icon={["far", "angle-left"]} />
                  </span>
                  <span
                    className="dynamicfieldselect-txt-title"
                    data-test="dynamicfieldselect-txt-title">
                    Add form field
                  </span>
                </div>
                <DynamicFieldFooter
                  onDiscard={this._onNavigationBack}
                  onSave={this._createDynamicField}
                  disabled={this.state.selectedId === ""}
                />
              </div>
              <div
                className="dynamicfieldselect-body"
                data-test="dynamicfieldselect-body">
                <div
                  className="dynamicfieldselect-txt-wrapper"
                  data-test="dynamicfieldselect-txt-wrapper">
                  <span
                    className="dynamicfieldselect-txt"
                    data-test="dynamicfieldselect-txt">
                    {this.props.selectedText}
                  </span>
                </div>
                <div
                  className="dynamicfieldselect-search-section"
                  data-test="dynamicfieldselect-search-section">
                  <span
                    className="dynamicfieldselect-search-title"
                    data-test="dynamicfieldselect-search-title">
                    Choose a relevant form field from this list for the selected
                    text
                  </span>
                  <Input
                    autoFocus
                    className="dynamicfieldselect-search-input"
                    data-test="dynamicfieldselect-search-input"
                    placeholder="Search available fields. Type _Date_"
                    value={this.state.filterBy}
                    onChange={event => this._onChangeValue("filterBy", event)}
                  />
                  <span
                    className="dynamicfieldselect-search-ico"
                    data-test="dynamicfieldselect-search-ico">
                    <FontAwesomeIcon icon={["far", "search"]} />
                  </span>
                  <div
                    className="dynamicfieldselect-note"
                    data-test="dynamicfieldselect-note">
                    <span>Note:</span> You can create a Custom field if you
                    don&apos;t find the one you need
                  </div>
                  {filteredFieldList.length === 0 ? (
                    <div className="dynamicfieldselect-note dynamicfieldselect-notfound-msg">
                      <span role="img" aria-label="Woman-Shrugging">
                        🤷‍♀️
                      </span>{" "}
                      We could not find any form field by the searched term. You
                      can create your own <strong>Custom Field</strong>
                    </div>
                  ) : null}
                </div>
                <div
                  className="dynamicfieldselect-options-wrapper"
                  data-test="dynamicfieldselect-options-wrapper"
                  onChange={event => this._onChange("selectedId", event)}>
                  <div className="dynamicfieldselect-options-scrollable">
                    {filteredFieldList.length !== 0 &&
                      filteredFieldList.map(option => (
                        <div
                          key={option.id}
                          className="dynamicfieldselect-options-section"
                          data-test="dynamicfieldselect-options-section">
                          <div
                            className="dynamicfieldselect-options-select"
                            data-test="dynamicfieldselect-options-select">
                            <Input
                              className="dynamicfiled-options"
                              data-test="input-revv-inp-checkbox-or-radio"
                              id={`${option.label}`}
                              type="radio"
                              value={option.id}
                              checked={this.state.selectedId === option.id}
                              name={option.label}
                              readOnly
                            />
                          </div>
                          <div
                            className="dynamicfieldselect-options-detail"
                            data-test="dynamicfieldselect-options-detail"
                            onClick={event => {
                              this._onChange("selectedId", event);
                            }}
                            onKeyDown={() => {}}
                            role="button"
                            tabIndex={0}>
                            <span
                              data-test="dynamicfieldselect-predefineddynamicfield-option-label"
                              value={option.id}>
                              {option.label}
                            </span>
                            <span
                              data-test="dynamicfieldselect-predefineddynamicfield-option-description"
                              value={option.id}>
                              {option.description}
                            </span>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <AddCustomDynamicField
              onNavigateToCustom={this._onNavigateToCustom}
            />
          </div>
          <div className="right-pane-bg" />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    editorState,
    fields: dynamicFields,
    section,
    selectedText,
    removeHighlightSelection,
  } = state.TemplateStore.dynamicFields;

  const { activeComponentMeta, components } = state.DocumentStore;

  const fields = dynamicFields.filter(
    field => field.type !== "CLAUSE" && field.type !== "IMAGE",
  );
  return {
    editorState,
    fields,
    section,
    selectedText,
    removeHighlightSelection,
    activeComponentMeta,
    components,
  };
};

const mapDispatchToProps = {
  getCustomFieldType,
  saveDynamicField,
  toggleDynamicFieldView,
  addDynamicFieldinList,
  updateHoveredTemplateSectionId,
  initEditorState,
  updateDocumentClickedComponentID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DynamicFieldSelect);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldSelect/DynamicFieldSelect.js